import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es seguro tener esto en papel?',
    a: 'Es más seguro tener un papel en su casa que una contraseña débil que cualquier hacker puede adivinar desde otro país.'
  }, {
    q: '¿Tengo que ser experta en computadoras?',
    a: 'No. Si sabe abrir su correo, puede hacer este método.'
  }, {
    q: '¿Cuánto tiempo toma?',
    a: 'Puede completar el 90% del sistema en una sola tarde de café.'
  }, {
    q: '¿Qué pasa si cambio mi contraseña?',
    a: 'El sistema incluye una regla de 10 minutos para actualizaciones trimestrales.'
  }, {
    q: '¿Sirve para cualquier país?',
    a: 'Sí, el Método del Ancla Analógica funciona universalmente.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-cream-dark" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-27">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gold/30 rounded-sm overflow-hidden shadow-sm" data-id="element-29">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:bg-cream/50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-30">
                <span className="text-xl font-bold text-burgundy pr-4" data-id="element-31">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-gold shrink-0" data-id="element-32" /> : <ChevronDown className="w-6 h-6 text-gold shrink-0" data-id="element-33" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-34">
                <p className="text-lg text-charcoal-light border-t border-cream-dark pt-4" data-id="element-35">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}